import React from "react";
import { STATS } from "@/constants/testIds";

const stats = [
  { value: "99%", label: "Clean claim rate", sub: "First-pass acceptance across payers" },
  { value: "40%", label: "Faster collections", sub: "Reduction in days in A/R on average" },
  { value: "10h+", label: "Saved per week, per biller", sub: "Hours back from repetitive follow-up" },
  { value: "1×", label: "Source of truth", sub: "One workspace for every practice and payer" },
];

export const Stats = () => {
  return (
    <section
      id="stats"
      data-testid={STATS.section}
      className="relative py-24 md:py-32 bg-zinc-950 text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-dark pointer-events-none [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_70%)]" />
      <div className="absolute inset-x-0 -top-40 h-[480px] bg-[radial-gradient(50%_50%_at_50%_50%,rgba(0,71,255,0.35),transparent_70%)] pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="font-mono-label text-[10px] text-[#7AA2FF]">
            // Why teams switch
          </span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-semibold tracking-tighter text-white">
            Outcomes a spreadsheet can&apos;t deliver.
          </h2>
          <p className="mt-5 text-lg text-zinc-300 max-w-2xl">
            Practices and billing teams using Zaplee.ai recover revenue they didn&apos;t
            know was leaking — and they see it move in real time.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {stats.map((s, i) => (
            <div
              key={i}
              className="bg-zinc-950 p-8 lg:p-10 transition-colors hover:bg-zinc-900"
            >
              <div className="font-display text-5xl sm:text-6xl font-semibold tracking-tighter text-white">
                {s.value}
              </div>
              <div className="mt-4 text-base font-medium text-white">
                {s.label}
              </div>
              <div className="mt-2 text-sm text-zinc-400 leading-relaxed">
                {s.sub}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
